/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTable: {
  name: 'table';
  data: string;
} = {
  name: 'table',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 .5A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h12a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2Zm3.5 14h5v-9h-5v9Zm-1-9v9H2a.5.5 0 0 1-.5-.5V5.5h3Zm.5-1h9.5V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v2.5H5Zm9 10h-2.5v-9h3V14a.5.5 0 0 1-.5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
